import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full h-full justify-start items-start bg-white overflow-y-auto" }
const _hoisted_2 = { class: "flex flex-col w-full h-full p-0 justify-start items-center" }
const _hoisted_3 = { class: "w-[960px] mt-4" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  text: "2xl",
  justify: "center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "w-full h-12 p-4 shadow-md" }, [
      _createElementVNode("span", { class: "text-large text-black text-bold font-600 mr-3" }, "Layout2")
    ], -1)),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex flex-col px-4 gap-4 mt-4 w-full items-center" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_carousel, {
          interval: 4000,
          type: "card",
          class: "w-full h-full"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carouselData, (item) => {
              return (_openBlock(), _createBlock(_component_el_carousel_item, {
                key: item.title
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: item.image,
                    alt: "Carousel Image",
                    class: "w-full h-full object-cover"
                  }, null, 8, _hoisted_4),
                  _createElementVNode("h3", _hoisted_5, _toDisplayString(item.title), 1),
                  _createElementVNode("p", null, _toDisplayString(item.description), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ])
    ])
  ]))
}